import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import Sidebar from './components/Sidebar';
// Public pages
import Home from './pages/Home';
import Features from './pages/Features';
import Pricing from './pages/Pricing';
import Solutions from './pages/Solutions';
import Contact from './pages/Contact';
import Login from './pages/Login';
import Register from './pages/Register';
// Protected pages (dashboard)
import Dashboard from './pages/Dashboard';
import AddMedicine from './pages/AddMedicine';
import SalesHistory from './pages/SalesHistory';
import Customers from './pages/Customers';
import Reports from './pages/Reports';
import EditMedicine from './pages/EditMedicine';
import Suppliers from './pages/Suppliers';
import Prescriptions from './pages/Prescriptions';
import Reminders from './pages/Reminders';
import PillSpinner from './components/PillSpinner';
import './App.css';

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <PillSpinner />;
  if (!user) return <Login />;
  return children;
};

const DashboardLayout = ({ children }) => (
  <div className="app-layout">
    <Sidebar />
    <div className="main-content">{children}</div>
  </div>
);

function App() {
  return (
    <Router>
      <AuthProvider>
        <Routes>
          {/* Public routes (marketing) */}
          <Route path="/" element={<Home />} />
          <Route path="/features" element={<Features />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/solutions" element={<Solutions />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />

          {/* Protected dashboard routes */}
          <Route path="/dashboard" element={
            <ProtectedRoute>
              <DashboardLayout><Dashboard /></DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/add-medicine" element={
            <ProtectedRoute>
              <DashboardLayout><AddMedicine /></DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/edit-medicine/:id" element={
            <ProtectedRoute>
              <DashboardLayout><EditMedicine /></DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/sales" element={
            <ProtectedRoute>
              <DashboardLayout><SalesHistory /></DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/customers" element={
            <ProtectedRoute>
              <DashboardLayout><Customers /></DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/reports" element={
            <ProtectedRoute>
              <DashboardLayout><Reports /></DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/suppliers" element={
            <ProtectedRoute>
              <DashboardLayout><Suppliers /></DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/prescriptions" element={
            <ProtectedRoute>
              <DashboardLayout><Prescriptions /></DashboardLayout>
            </ProtectedRoute>
          } />
          <Route path="/reminders" element={
            <ProtectedRoute>
              <DashboardLayout><Reminders /></DashboardLayout>
            </ProtectedRoute>
          } />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;